import React from 'react';
import { getDefaultValue, getStates } from 'swag-common/utils/shipping';
import { Select } from 'swag-client-common/components/pickers/select-field';
const StatePicker = ({
  value,
  floatingLabelText = undefined,
  onChange,
  disabled = false,
  fullWidth = false,
  autoWidth = true,
  style,
  dataDropdown = 'State',
  wrapperClassName = '',
  className = undefined,
  hintText = 'Select a state',
  hintStyle = undefined,
  country = undefined,
  selectionRenderer = undefined,
  valueOutsideList = undefined
}) => {
  const options = getStates(country || '').map(({
    code,
    name
  }) => ({
    value: code,
    key: `${name}${code}`,
    label: `${name} (${code})`,
    isHidden: false
  }));
  if (valueOutsideList) {
    options.push({
      value: String(valueOutsideList),
      label: String(valueOutsideList),
      key: String(valueOutsideList),
      isHidden: true
    });
  }
  return /*#__PURE__*/React.createElement(Select, {
    dataDropdown: dataDropdown,
    disabled: disabled,
    value: value || getDefaultValue(country) || '',
    onChange: onChange,
    floatingLabelText: floatingLabelText,
    fullWidth: fullWidth,
    autoWidth: autoWidth,
    style: style,
    wrapperClassName: wrapperClassName,
    hintText: hintText,
    className: className,
    options: options
  });
};
export { getDefaultValue, StatePicker };